import { AccountMenu } from "../AccountMenu";

// Account menu of the admin area: same look as the seller UserMenu, without
// the seller-only entries (currency, workspace, extension).
export const AdminUserMenu = () => <AccountMenu menuId="admin-account-menu" />;
